import React from 'react';

const CornerTypesPopupContent = ({ corners }) => {
  return (
    <div className="pop-up__content">
      <div className="pop-up__content--padding">
        Szafy narożne występują w dwóch wariantach.
        <p>
          Pierwszy umożliwia łączenie szaf wyłącznie o głębokości 70 cm. Elementem
          charakterystycznym tego narożnika są drzwi szafy pod kątem 45 stopni.
        </p>
        {corners.map(item => (item.id === 11 ? <img src={item.url} key={item.id} alt="" /> : null))}
        <p>
          Drugi umożliwia łączenie szaf o głębokości 70 cm z szafami o głębokości 70 cm lub 45 cm.
        </p>
        {corners.map(item =>
          item.id === 10 || item.id === 9 ? <img src={item.url} key={item.id} alt="" /> : null,
        )}
        <p>
          W przypadku łączenia dwóch szaf o głębokości 70 cm, musi on zostać lekko odsunięty od
          ściany.
        </p>
        <p>
          W przypadku łączenia szafy o głębokości 66 cm szafą o głębokości 45 cm, dowolne jest,
          która z nich znajdzie się po lewej stronie a która po prawej. Ten typ szafy narożnej
          umożliwia bowiem montaż w dwóch symetrycznych wariantach.
        </p>
      </div>
    </div>
  );
};

export default CornerTypesPopupContent;
